import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { UserContext } from "UserContext";
import "./styles.scss";
import axios from "axios";
import { ShimmerCompanyCard } from "CompanyCard";
import ConnectSubscribeButtonGroup from "ConnectSubscribeButtonGroup";
import { Modal } from "react-bootstrap";
import { generalUtils } from "utilities";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "@reach/router";
import { useCompanyTags } from "queryHooks";

const CompanyCard = (props) => {
  const company = props.company;

  const {
    data: companyTags = [],
    status: fetchCompanyTagsStatus,
    error: companyTagsError,
  } = useCompanyTags({
    companyId: company.company_id,
    refetchOnWindowFocus: false,
  });

  let navigate;
  if (props.useCompanyCardAnchorLink !== true) {
    navigate = useNavigate();
  }

  const cardImageStyle = {
    backgroundSize: "100%",
    backgroundImage: `url(${company.card_header_image_url})`,
  };

  const cardColorStyle = {
    background: `#${company.primary_color}`,
  };

  let cardHeroStyle = company.card_header_image_url
    ? cardImageStyle
    : cardColorStyle;

  let banner_videos = [];

  if (company && company.media) {
    banner_videos = company.media.filter(
      (item) => item.type == "company_banner_video"
    );
  }

  const isCalendarUrlValid = () => {
    if (company.calendar_url) {
      return true;
    }
    return false;
  };

  let video;
  if (banner_videos[0]) {
    video = banner_videos[0];
  }

  const [showVideoModal, setShowVidoModal] = useState(false);
  const handleCloseVideoModal = () => setShowVidoModal(false);
  const handleShow = () => setShowVidoModal(true);

  let videoCardBannerPadding = "50.3%";
  if (company.display_video_card_banner && video && video.id) {
    if (video.video_host === "youtube") {
      videoCardBannerPadding = "56.25%";
    } else if (video.video_host === "vimeo") {
      videoCardBannerPadding = "54.3%";
    }
  }

  const cardBackgroundHtml = (
    <div style={{ position: "relative" }}>
      {company.display_video_card_banner && video && video.id && (
        <React.Fragment>
          <div className="ps-company-card__banner-play-icon-container">
            <div
              onClick={(e) => {
                e.preventDefault();
                handleShow();
              }}
              className="ps-company-card__play-icon-badge"
            >
              <span className="ps-company-card__play-icon"></span>
            </div>
          </div>
          <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showVideoModal}
            onHide={handleCloseVideoModal}
            animation={false}
          >
            <div
              className="ps-company-card__modal-exit-button"
              onClick={() => {
                handleCloseVideoModal();
              }}
            >
              <img src="/images/icons/black-x-mark.svg" />
            </div>
            <Modal.Body
              className={"d-flex"}
              style={{
                position: "relative",
                paddingBottom: videoCardBannerPadding,
                height: 0,
                overflow: "hidden",
                maxWidth: "100%",
                borderRadius: "10px",
              }}
            >
              {video.video_host === "youtube" && (
                <iframe
                  src={`https://www.youtube.com/embed/${video.video_id}?autoplay=1`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                ></iframe>
              )}
              {video.video_host === "wistia" && (
                <div>
                  <script
                    src={`https://fast.wistia.com/embed/medias/${video.video_id}.jsonp`}
                    async
                  ></script>
                  <script
                    src="https://fast.wistia.com/assets/external/E-v1.js"
                    async
                  ></script>
                  <div
                    className="wistia_responsive_padding"
                    style={{ padding: "56.25% 0 0 0", position: "relative" }}
                  >
                    <div
                      className="wistia_responsive_wrapper"
                      style={{
                        height: "100%",
                        left: 0,
                        position: "absolute",
                        top: 0,
                        width: "100%",
                      }}
                    >
                      <div
                        className={`wistia_embed wistia_async_${video.video_id} videoFoam=true`}
                        style={{
                          height: "100%",
                          position: "relative",
                          width: "100%",
                        }}
                      >
                        <div
                          className="wistia_swatch"
                          style={{
                            height: "100%",
                            left: 0,
                            opacity: 1,
                            overflow: "hidden",
                            position: "absolute",
                            top: 0,
                            transition: "opacity 200ms",
                            width: "100%",
                          }}
                        >
                          <img
                            src={`https://fast.wistia.com/embed/medias/${video.video_id}/swatch`}
                            style={{
                              filter: "blur(5px)",
                              height: "100%",
                              objectFit: "cover",
                              width: "100%",
                            }}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {video.video_host === "vimeo" && (
                <iframe
                  className=""
                  src={`https://player.vimeo.com/video/${video.video_id}?autoplay=1`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                ></iframe>
              )}
            </Modal.Body>
          </Modal>
        </React.Fragment>
      )}
      <div
        className="ps-company-card__background-container"
        style={cardHeroStyle}
      ></div>
    </div>
  );

  const logoContainerHtml = (
    <div className="ps-company-card__logo-container">
      <img
        src={company.logo_url ? company.logo_url : company.secondary_logo_url}
        className="ps-company-card__logo"
        alt="Company Logo"
      />
      <div className="ps-company-card__header-icons-container">
        {isCalendarUrlValid() && (
          <div className="ps-company-card__calendar-icon-container">
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip id="tooltip-calendar">Schedule Meeting</Tooltip>
              }
            >
              <a
                href={company.calendar_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/images/icons/calendar-black-icon.svg" />
              </a>
            </OverlayTrigger>
          </div>
        )}
      </div>
    </div>
  );

  const companyDisplayNameHtml = (
    <h1 className="ps-company-card__text">{company.display_name}</h1>
  );

  const dynamicAnchorWrappedComponent = (component) => (
    <React.Fragment>
      {props.enableLinkToProfile && (
        // <a
        //   href={`/${company.name}`}
        //   data-company-name={company.name}
        //   data-project-id={company.company_id}
        // >
        //   {component}
        // </a>
        <div
          // href={`/${company.name}`}
          onClick={() => {
            if (props.useCompanyCardAnchorLink === true) {
              window.location.href = `/${company.name}`;
            } else {
              navigate(`/${company.name}`);
            }
          }}
          className="ps-company-card__with-company-data-container"
          data-company-name={company.name}
          data-project-id={company.company_id}
        >
          {component}
        </div>
      )}

      {!props.enableLinkToProfile && component}
    </React.Fragment>
  );

  let getCompanyTags = () => {
    let tags = [];
    tags = companyTags
      ? companyTags.filter((tag) => {
          if (tag.tag_type === "market_tag") {
            return true;
          } else {
            return false;
          }
        })
      : [];

    return tags;
  };

  const tagsHtml = getCompanyTags().map((tag, index) => {
    return (
      <div className="ps-company-card__tag" key={index}>
        <span className="ps-company-card__tag-text">
          {typeof tag === "string" ? tag : tag.display_name}
        </span>
      </div>
    );
  });

  return (
    <React.Fragment>
      <div>
        <div className="ps-company-card ps-card--primary ps-card--auto-height js-company-card">
          {!company.name && <ShimmerCompanyCard />}

          {company.name && (
            <React.Fragment>
              {dynamicAnchorWrappedComponent(cardBackgroundHtml)}

              <div className="ps-company-card__body">
                {dynamicAnchorWrappedComponent(logoContainerHtml)}

                <div className="ps-company-card__text-container">
                  {dynamicAnchorWrappedComponent(companyDisplayNameHtml)}
                  <div
                    className="ps-company-card__website-link"
                    style={{
                      opacity: company.website_url ? 1 : 0,
                    }}
                  >
                    <a
                      href={company.website_url ? company.website_url : ""}
                      rel="noopener noreferrer"
                      target="_blank"
                      data-company-name={company.name}
                      data-project-id={company.project_id}
                      data-tracking-id="visit-company-website"
                    >
                      {company.website_url
                        ? generalUtils.shortenUrlForDisplay(company.website_url)
                        : ""}
                    </a>
                  </div>

                  <div className="ps-company-card__tags-container">
                    {tagsHtml}
                  </div>

                  <h3
                    className="ps-company-card__subtext js-truncate-text js-read-more mb-3"
                    data-read-more="true"
                    data-length="115"
                    data-url={`/${name}`}
                  >
                    {company.short_description}
                  </h3>
                </div>

                <div className="ps-company-card__buttons-container">
                  {props.enableLinkToProfile && (
                    <button
                      className="btn ps-btn--white ps-btn--full mr-3"
                      onClick={() => {
                        if (props.useCompanyCardAnchorLink === true) {
                          window.location.href = `/${company.name}`;
                        } else {
                          navigate(`/${company.name}`);
                        }
                      }}
                    >
                      View Profile
                    </button>
                  )}

                  <ConnectSubscribeButtonGroup
                    company={company}
                    respectSubscribeInUrl={true}
                  />
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CompanyCard;

CompanyCard.propTypes = {
  company: PropTypes.object,
  enableLinkToProfile: PropTypes.bool,
  useNamespaceTags: PropTypes.bool,
};
